<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
  <div class="row unselectable headerTitle headline">{{translation.Transport}}</div>
  <div class="breakLine"></div>
  <div id="moduleContent" class="row unselectable">
    <app-module *ngIf="transportTaskModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="transportTaskModule" (click)="navigate(transportTaskModule.ForwardLink)"></app-module>
    <app-module *ngIf="damageReportModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="damageReportModule" (click)="navigate(damageReportModule.ForwardLink)"></app-module>
    <app-module *ngIf="damageCaseModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="damageCaseModule" (click)="navigate(damageCaseModule.ForwardLink)"></app-module>
    <app-module *ngIf="homeDeliveryTaskModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" [module]="homeDeliveryTaskModule" (click)="navigate(homeDeliveryTaskModule.ForwardLink)"></app-module>
  </div>
</div>
<app-footer></app-footer>
